export const EventType = {
	EVENT:  'event',
	UPLOAD: 'upload',
	CLIP:   'clip',
};
